import { render, staticRenderFns } from "./IconSvgDownloads.vue?vue&type=template&id=57c5d148&scoped=true&"
import script from "./IconSvgDownloads.vue?vue&type=script&lang=js&"
export * from "./IconSvgDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5d148",
  null
  
)

export default component.exports